export default __webpack_public_path__ + "static/media/digest-preview-2.e7e86ece.svg";